import { useAuthStore } from '@/stores/authStore'

/**
 * Returns the current user's Convex `_id`.
 *
 * Reads from the auth store (synced by AuthSyncProvider from
 * `api.profile.getMyProfile`). Use this wherever a user ID is needed
 * in API calls.
 */
export const useCurrentUserId = (): string | undefined => {
  return useAuthStore((s) => s.user?.userId) ?? undefined
}
